import { api } from './axios';
import { ParticipantEntity } from '../interfaces/participant';

const addParticipant = async (data: ParticipantEntity) => {
  const participantQuery = `mutation addParticipant($data: CreateParticipantInput) {
    addParticipant (input: $data) {
      consent
      email
      employment
      eventId
      fio
      occupation
      phone
    }
  }`;

  const response = api
    .post('', {
      query: participantQuery,
      operationName: 'addParticipant',
      variables: {
        data: data
      }
    })
    .then((res) => res.data)
    .catch((res) => res.data);

  return response;
};

export { addParticipant };
